import React from 'react';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import {
  Header,
  HeaderContent,
  HeaderImage,
  NeedHelpStyle,
  HelpTextContainer,
  Title,
  TitleHolder,
  SuccessAccountMessage,
  SuccessAccountWrapper,
} from '../common/styledComponents';
import LinkText from '../../../components/LinkText/LinkText';
import CustomScrollBar from '../../../components/CustomScrollBar';
import FormContent from './components/FormContent';

export const SignUpForm = (props) => {
  const {
    title,
    onPressHelp,
    isModal,
    postSignupData,
    withScroll = true
  } = props;

  return (
    <>
      {isModal && (
        <Header>
          <HeaderImage
            source={assetSource(ASSET_KEY.FULL_MODAL_HEADER)}
            ibw={require(asset`full-modal-header.ibw`)}
            style={{ position: 'absolute' }}
          >
            <HeaderContent>
              <TitleHolder>
                <Title data-label={title || ''}>
                  {title || ''}
                </Title>
              </TitleHolder>
              <HelpTextContainer onClick={onPressHelp}>
                <LinkText customStyle={NeedHelpStyle} underline={false}>
                  {getText(TEXT_KEY.NEED_HELP)}
                </LinkText>
              </HelpTextContainer>
            </HeaderContent>
          </HeaderImage>
        </Header>
      )}

      {!postSignupData?.success ? (
        withScroll ? <CustomScrollBar><FormContent {...props}/></CustomScrollBar> : <FormContent {...props}/>
      ) : (
        <SuccessAccountWrapper>
          <SuccessAccountMessage>{postSignupData.msg}</SuccessAccountMessage>
        </SuccessAccountWrapper>
      )}
    </>
  );
};

